import { createContext } from 'react'

const LayoutContext = createContext({
    activeSidebar: true,
    sidebarToggleHandler: () => {}
})

export default LayoutContext